import { AuthLogin } from "@components/resolvers/auth.resolver";
import { AuthLoginResponse } from "@services/dtos/auth.dto";
import { BaseService } from "@services/base.service";
import Cookies from "js-cookie";
import moment from "moment";
import { androidSaveDataBiometric } from "@utils/android";

interface AuthServiceInterface {
  login(payload: AuthLogin): Promise<AuthLoginResponse>;
}

export const AuthService: AuthServiceInterface = {
  login: async (payload) => {
    try {
      const request = await BaseService.request().post<AuthLoginResponse>(
        "/auth/login",
        payload
      );
      const response = request.data.data!;
      const token = response.token.type + " " + response.token.token;

      // Cookies.set("gender", response.gender, {
      //   expires: moment(response.token.eat).toDate(),
      // });
      Cookies.set("token", token, {
        expires: moment(response.token.eat).toDate(),
      });
      Cookies.set("redirect", response.redirect, {
        expires: moment(response.token.eat).toDate(),
      });

      androidSaveDataBiometric(payload);

      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
